<script>
import modal from '@/components/view/modal'
export default {
  components: {
    'gp-modal': modal
  },
  props: {
    specialId: {
      type: String,
      required: true
    }
  },
  computed: {
    special () {
      return this.docs.special[this.specialId]
    },
    query () {
      return this.special.twitter.replace(/#/g, '%23')
    },
    shareUrl () {
      const path = this.special.shareUrl || '/'
      return `https://twitter.com/share?url=https://www.greatpretender.jp${path}&text=${this.query}`
    }
  }
}
</script>

<template>
  <gp-modal>
    <div class="gp-special-article">
      <article class="level">
        <div
          class="content"
          v-html="special.text"
          :class="{'no-indent': special.indent === false}"
        >
        </div>
        <div
          v-if="special.button"
          class="twitter"
        >
          <a
            :href="shareUrl"
            target="_blank"
            rel="noopener"
          >
            <button class="is-size-2 is-size-3-mobile has-text-weight-bold">
              {{ special.button }}
            </button>
          </a>
        </div>
      </article>
    </div>
  </gp-modal>
</template>

<style lang="scss">
.gp-special-article {
  .content {
    &.no-indent {
      p {
        text-indent: 0;
      }
    }
    .is-yellow {
      color: $yellow;
    }
    figure {
      margin: 2rem auto;
      max-width: 60rem;
      max-height: 60rem;
      &.is-large {
        @include is-not-mobile {
          max-width: 50rem;
          max-height: 50rem;
        }
        @include is-mobile {
          max-width: 100%;
        }
        img {
          @include is-not-mobile {
            display: block;
            max-width: 50rem;
            max-height: 50rem;
          }
          @include is-mobile {
            max-width: 100%;
          }
        }
      }
      img {
        max-width: 100%;
        max-height: calc(60rem - 4rem);
        width: auto;
        margin: 0 auto;
      }
    }
    figcaption {
      color: $yellow;
      margin-top: 2rem;
    }
    > *:not(figure) {
      max-width: 50rem;
      margin: auto;
    }
    h2 {
      margin-bottom: .5rem;
      @include is-mobile {
        font-size: 1rem;
      }
      @include is-not-mobile {
        font-size: 1.25rem;
      }
    }
    p {
      text-indent: 1em;
      @include is-mobile {
        font-size: 13px;
        line-height: 22px;
      }
      @include is-not-mobile {
        font-size: 16px;
        line-height: 28px;
      }
      em {
        font-weight: bold;
        font-style: normal;
      }
    }
    .title {
      color: $yellow;
      font-weight: bold;
      @include is-mobile {
        font-size: 35px;
        line-height: 40px;
        margin-bottom: .5rem;
      }
      @include is-not-mobile {
        font-size: 45px;
        line-height: 50px;
        margin-bottom: 1rem;
      }
    }
    > time {
      font-family: Oswald;
      color: $yellow;
      font-weight: bold;
      @include is-mobile {
        font-size: 14px;
        line-height: 1.25rem;
      }
      @include is-not-mobile {
        font-size: 18px;
        line-height: 1.5rem;
      }
    }
    .star {
      color: $yellow;
      font-weight: bold;
      &.is-large {
        @include is-mobile {
          font-size: 1.25rem;
        }
        @include is-not-mobile {
          font-size: 1.5rem;
        }
      }
    }
    .comments {
      article {
        border: solid 2px $yellow;
        border-radius: 6px;
        @include is-mobile {
          margin: 1rem auto;
          padding: 1rem .75rem;
        }
        @include is-not-mobile {
          margin: 1.5rem auto;
          padding: 1.5rem 2.25rem;
        }
        header {
          color: $yellow;
          display: flex;
          align-items: center;
          justify-content: space-between;
          @include is-mobile {
            font-size: 1rem;
          }
          @include is-not-mobile {
            font-size: 1.25rem;
          }
          h1 {
            font-weight: bold;
          }
        }
        > div {
          @include is-mobile {
            margin-top: 1rem;
            font-size: 13px;
          }
          @include is-not-mobile {
            margin-top: 1.5rem;
          }
          span {
            display: inline-block;
            @include is-mobile {
              padding-right: 1rem;
            }
            @include is-not-mobile {
              width: 12rem;
            }
          }
          time {
            font-weight: normal;
            color: $black;
          }
        }
        p {
          text-indent: 0;
          margin-top: .5rem;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.gp-special-article {
  background-color: #A348EB;
  background-color: rgba(163, 72, 235, .95);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  * {
    pointer-events: auto;
  }
  article {
    flex-direction: column;
    @include is-not-mobile {
      min-width: 65rem;
      margin: 3rem auto;
    }
    @include is-mobile {
      margin: 4rem 1.5rem;
    }
    .content {
      @include is-not-mobile {
        max-width: 60rem;
        margin: auto;
      }
    }
    .twitter {
      button {
        display: block;
        margin: 3rem auto;
        cursor: pointer;
        background-color: $white;
        border-radius: 10rem;
        border: solid 4px $black;
        min-width: 18.75rem;
        height: 3.75rem;
        padding: 0 1.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/special/special-article.vue